import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/totalVisitsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PeriodType = () => {
  const dispatch = useDispatch();

  const periodTypeOptions = useSelector((state) => state.totalVisits.periodTypeOptions);
  const selectedPeriodTypeOptions = useSelector(
    (state) => state.totalVisits.selectedFilters.period_type
  );

  return (
    <MultiSelectDropdown
      options={periodTypeOptions}
      selectedFilters={selectedPeriodTypeOptions}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodType(data))}
    />
  );
};

export default PeriodType;
